import React, { useEffect } from 'react';
import { useApp } from '@/context/AppContext';
import { ChatPanel } from '@/components/ChatPanel';
import { Sparkles, X } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';

export const AdvisorFab = () => {
  const { advisorOpen, setAdvisorOpen, t } = useApp();
  if (advisorOpen) return null;
  return (
    <button
      onClick={() => setAdvisorOpen(true)}
      data-testid="advisor-fab"
      className="fixed z-40 bottom-20 lg:bottom-6 right-4 lg:right-6 xl:hidden flex items-center gap-2 h-13 pl-3.5 pr-4 py-3 rounded-full text-white shadow-xl shadow-cyan-500/30 hover:scale-105 transition-transform"
      style={{ background: 'linear-gradient(135deg, #06B6D4 0%, #7C3AED 100%)' }}
      aria-label={t('advisor.open')}
    >
      <Sparkles className="w-5 h-5" />
      <span className="hidden sm:block text-sm font-semibold">{t('nav.advisor')}</span>
    </button>
  );
};

export const AdvisorDrawer = () => {
  const { advisorOpen, setAdvisorOpen, t } = useApp();
  useEffect(() => {
    if (!advisorOpen) return;
    const onKey = (e) => { if (e.key === 'Escape') setAdvisorOpen(false); };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [advisorOpen, setAdvisorOpen]);
  return (
    <AnimatePresence>
      {advisorOpen && (
        <>
          <motion.div
            initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}
            onClick={() => setAdvisorOpen(false)}
            className="fixed inset-0 z-50 bg-black/30 backdrop-blur-sm"
          />
          <motion.div
            initial={{ x: '100%' }} animate={{ x: 0 }} exit={{ x: '100%' }}
            transition={{ type: 'spring', damping: 30, stiffness: 300 }}
            className="fixed z-50 top-0 right-0 h-full w-full sm:w-[420px] bg-white shadow-2xl flex flex-col"
            data-testid="advisor-drawer"
          >
            <div className="flex items-center justify-between px-5 h-16 border-b border-zinc-200 shrink-0" style={{ background: 'linear-gradient(135deg, #0891B2 0%, #7C3AED 100%)' }}>
              <div className="flex items-center gap-2 text-white">
                <Sparkles className="w-5 h-5" />
                <div>
                  <p className="font-heading font-semibold leading-tight">{t('advisor.title')}</p>
                  <p className="text-[11px] text-white/80">{t('advisor.subtitle')}</p>
                </div>
              </div>
              <button onClick={() => setAdvisorOpen(false)} data-testid="advisor-close" className="w-8 h-8 rounded-lg hover:bg-white/20 text-white flex items-center justify-center transition-colors">
                <X className="w-5 h-5" />
              </button>
            </div>
            <div className="flex-1 min-h-0">
              <ChatPanel compact />
            </div>
          </motion.div>
        </>
      )}
    </AnimatePresence>
  );
};
